export interface Initializable {
    init: () => void
}

export function isInitializable(item: any): item is Initializable {
    return _.isObject(item) && _.isFunction(item.init);
}